import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  FormFeedback,
  Input,
  FormGroup,
} from "reactstrap";
import Dropzone from "react-dropzone";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { createBanner, updateBanner } from "services/MobileBanner.service";
import Spinner from "components/spinner";
import getImageUrl from "utils/getImageUrl";
import ProfileImage from "components/profileImage";
import {
  CreateParentCaregory,
  UpdateParentCategory,
} from "services/V2_APIs/DoctorsConsultationApis/parentCategories.service";

const defaultValues = {
  name: "",
  image: "",
  order: 0,
  //   text: "",
  status: "",
  tagline: "",
  description: "",
  genderType: "",
};

const CreateParentCategory = ({
  toggle,
  modal,
  reload,
  SelectedParentcatdata,
}) => {
  const [selectedType, setSelectedType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  const [values, setValues] = useState(defaultValues);
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState();

  const statusList = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];
  const typeList = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Unisex", value: "Unisex" },
  ];
  const initialValues = SelectedParentcatdata
    ? { ...defaultValues, ...SelectedParentcatdata }
    : defaultValues;

  const validationSchema = Yup.object().shape({
    status: Yup.string().required("Please Select status"),
    image: Yup.string().required("Please Upload Image"),
  });
  const onSubmit = values => {
    console.log(values, "vall");
    if (SelectedParentcatdata) {
      editChanges(values);
    } else {
      saveChanges(values);
    }
  };
  // const { image } = values;
  function handleSelectType(event) {
    setValues({ ...values, ["genderType"]: event.value });
    setSelectedType(event);
  }
  function handleSelectStatus(event) {
    setValues({ ...values, ["status"]: event.value });
    setSelectedStatus(event);
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const saveChanges = values => {
    setLoading(true);
    let body = {
      ...values,
      image: logo,
    };
    CreateParentCaregory(body)
      .then(res => {
        if (res?.success === true) {
          setsuccess_msg(true);
        } else {
          seterror_msg(true);
        }
        setLoading(false);
        reload();
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };

  const editChanges = values => {
    setLoading(true);
    let body = {
      ...values,
      image: logo,
    };
    UpdateParentCategory(body, SelectedParentcatdata?._id)
      .then(res => {
        if (res?.success) {
          setsuccess_msg(true);
        } else {
          seterror_msg(true);
        }
        setLoading(false);
        reload();
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };

  const leaveToList = () => {
    toggle();
    setsuccess_msg(false);
    seterror_msg(false);
    setValues(defaultValues);
    setSelectedType({});
    setSelectedStatus({});
    setLogo("")
  };
  const stayHere = () => {
    setsuccess_msg(false);
    seterror_msg(false);
  };

  const successPopup = () => {
    return (
      <SweetAlert
        title="Success"
        success
        onConfirm={leaveToList}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="primary"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Leave
            </Button>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              Continue
            </Button>
          </React.Fragment>
        }
      >
        {SelectedParentcatdata
          ? "Successfully Parent Category Edited"
          : "Successfully Parent Category created"}
      </SweetAlert>
    );
  };

  const errorPopup = () => {
    return (
      <SweetAlert
        title="Failure"
        danger
        onConfirm={leaveToList}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Leave
            </Button>
            <Button
              color="danger"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              Continue
            </Button>
          </React.Fragment>
        }
      >
        Something went wrong
      </SweetAlert>
    );
  };

  return (
    <>
      <Spinner loading={loading} />
      <Modal isOpen={modal} toggle={toggle} backdrop="static" size="lg">
        <ModalHeader toggle={toggle}>
          {SelectedParentcatdata
            ? "Edit Parent Category"
            : "Create Parent Category"}
        </ModalHeader>
        <ModalBody className="bg-light">
          <Container fluid={false}>
            <Card>
              <CardBody>
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  // onSubmit={onSubmit}
                >
                  {({
                    errors,
                    touched,
                    isSubmitting,
                    setFieldValue,
                    handleChange,
                    setFieldTouched,
                    values,
                  }) => {
                    useEffect(() => {
                      if (SelectedParentcatdata) {
                        setSelectedStatus({
                          label: SelectedParentcatdata?.status,
                          value: SelectedParentcatdata?.status,
                        });
                        setSelectedType({
                         label: SelectedParentcatdata?.genderType,
                          value: SelectedParentcatdata?.genderType, 
                        })
                        setLogo(SelectedParentcatdata?.image)
                      }
                    }, [SelectedParentcatdata]);

                    return (
                      <Form>
                        <Row className="mt-4">
                          <Col md={6}>
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">Name</Label>
                              <Input
                                name="name"
                                placeholder="Name"
                                type="text"
                                className="form-control"
                                id="name"
                                onChange={handleChange}
                                // onBlur={validation.handleBlur}
                                value={values.name}
                                invalid={
                                  touched.name && errors.name ? true : false
                                }
                              />

                              {touched.name && errors.name ? (
                                <FormFeedback type="invalid">
                                  {errors.name}
                                  {touched.name}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup className="mb-3">
                              <Label htmlFor="genderType">Type</Label>
                              <Select
                                // className="form-control"
                                id="genderType"
                                value={selectedType}
                                onChange={event => {
                                  handleSelectType(event);
                                  handleChange("genderType")(event.value);
                                }}
                                name="genderType"
                                options={typeList}
                                classNamePrefix="select2-selection"
                              />
                              <Label className="statusValidation">
                                {" "}
                                {errors.type ? errors.type : ""}
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup className="mb-3">
                              <Label htmlFor="Status">Status</Label>
                              <Select
                                // className="form-control"
                                id="Status"
                                value={selectedStatus}
                                onChange={event => {
                                  handleSelectStatus(event);
                                  handleChange("status")(event.value);
                                }}
                                name="status"
                                options={statusList}
                                classNamePrefix="select2-selection"
                              />
                              <Label className="statusValidation">
                                {errors.status ? errors.status : ""}
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col md={6} className="px-4">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">Order</Label>
                              <Input
                                name="order"
                                placeholder="Order"
                                type="text"
                                className="form-control"
                                id="order"
                                onChange={handleChange}
                                value={values.order}
                              />

                              {touched.name && errors.name ? (
                                <FormFeedback type="invalid">
                                  {errors.name}
                                  {touched.name}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                          <Col md={12}>
                            <Label>Tagline</Label>
                            <CKEditor
                              editor={ClassicEditor}
                              id="tagline"
                              data={values?.tagline || ""}
                              onReady={editor => {
                                if (values?.tagline)
                                  editor.data.set(values?.tagline);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue("tagline", data);
                              }}
                            />
                          </Col>
                          <Col md={12} className="mt-3">
                            <Label>Description</Label>
                            <CKEditor
                              editor={ClassicEditor}
                              id="description"
                              data={values?.description || ""}
                              onReady={editor => {
                                if (values?.description)
                                  editor.data.set(values?.description);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue("description", data);
                              }}
                            />
                          </Col>
                          <Col md={12} className="mt-3">
                            <Row className="mb-3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="validationCustom06">
                                  Image
                                </Label>
                                <div className="d-flex flex-wrap">
                                  <Dropzone
                                    onDrop={async acceptedFiles => {
                                      acceptedFiles.map(file =>
                                        Object.assign(file, {
                                          preview: URL.createObjectURL(file),
                                          formattedSize: formatBytes(file.size),
                                        })
                                      );

                                      const imgUrl = await getImageUrl({
                                        image: acceptedFiles,
                                      });
                                      setLogo(imgUrl);
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div className="dropzone image_drop">
                                        <div
                                          className="dz-message needsclick"
                                          {...getRootProps()}
                                        >
                                          <input {...getInputProps()} />
                                          <div className="">
                                            <i className="display-6 text-muted bx bxs-cloud-upload" />
                                          </div>
                                          <h6>
                                            Drop files here or click to upload.
                                          </h6>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  <div
                                    className="dropzone-previews ms-3"
                                    id="file-previews"
                                  >
                                    {logo && (
                                      <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                        <div className="p-2">
                                          <Row className="align-items-center">
                                            <Col className="col-auto">
                                              <ProfileImage
                                                image={logo}
                                                height="80"
                                                classNames="avatar-sm rounded bg-light"
                                              />
                                            </Col>
                                            <Col>
                                              <Button
                                                color="danger"
                                                size="sm"
                                                onClick={() => setLogo(null)}
                                              >
                                                Remove
                                              </Button>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Card>
                                    )}
                                  </div>
                                </div>
                              </FormGroup>
                            </Row>
                          </Col>
                        </Row>
                        <hr></hr>
                        <div className="d-flex justify-content-end">
                          <Button
                            color="light"
                            className="w-md btn-sm me-3"
                            onClick={leaveToList}
                          >
                            cancel
                          </Button>
                          {!SelectedParentcatdata ? (
                            <Button
                              color="primary"
                              type="submit"
                              className="w-md btn-sm"
                              onClick={() => onSubmit(values)}
                            >
                              Submit
                            </Button>
                          ) : (
                            <Button
                              color="primary"
                              className="w-md btn-sm"
                              type="submit"
                              onClick={() => onSubmit(values)}
                            >
                              Save Changes
                            </Button>
                          )}
                        </div>
                      </Form>
                    );
                  }}
                </Formik>

                {success_msg ? successPopup() : null}
                {error_msg ? errorPopup() : null}
              </CardBody>
            </Card>
          </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreateParentCategory;
